<template>
  <v-container fluid pa-0>
    <a-search :show="false" :title="$t('roles')" icon="supervised_user_circle" />
    <v-layout row wrap justify-center style="margin-top:-65px">
      <v-card class="flex xs11 border elevation-0 mb-5">
        <v-toolbar color="grey lighten-3 elevation-0">
          <v-btn color="primary" v-if="can.add" @click="show=true">{{$t('new_record')}}</v-btn>
          <v-spacer />
        </v-toolbar>

        <v-expansion-panel right class="flex xs12">
          <v-expansion-panel-content v-for="item in items" :key="item.id">
            <div slot="header" class="lr--text">
              <strong>{{item.name}}</strong>
            </div>
            <viewRole
              :name="item.name"
              @edit="setForEdit(item)"
              @delete="setForDelete(item)"
              :permissions="item.permissions"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-dialog v-if="show" v-model="show" max-width="800px" transition="dialog-transition">
          <newRole @saved="saved" @closed="reset" :role="roleForEdit" v-if="can.add || can.edit" />
        </v-dialog>
      </v-card>
    </v-layout>
  </v-container>
</template> 
 
<script>
import newRole from "./newRole.vue";
import viewRole from "./viewRole.vue";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "roles",
  components: { viewRole, newRole },
  data() {
    return {
      items: [],
      show: false,
      loading: true,
      deleteId: null,
      edit_index: -1,
      roleForEdit: {
        id: null,
        name: null,
        permissions: []
      }
    };
  },
  computed: {
    can() {
      return {
        add: this.userCan("add_roles"),
        edit: this.userCan("edit_roles"),
        delete: this.userCan("delete_roles"),
        any: this.userCan("edit_roles") || this.userCan("delete_roles")
      };
    }
  },
  methods: {
    getRoles() {
      this.loading = true;
      this.axios
        .get("roles")
        .then(res => {
          this.items = res.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    getAllPermissions() {
      this.axios.get("roles/create").then(resp => {
        this.roleForEdit.permissions = resp.data.data;
        this.roleForEdit.id = null;
        this.roleForEdit.name = null;
      });
    },
    setForEdit(item) {
      this.edit_index = this.items.indexOf(item);
      // set item permissions
      this.roleForEdit.permissions = Object.assign(
        {},
        this.roleForEdit.permissions,
        item.permissions
      );
      this.roleForEdit.id = item.id;
      this.roleForEdit.name = item.name;
      this.show = true;
    },

    setForDelete(item) {
      let vm = this;
      const index = this.items.indexOf(item);
      this.$alert("roles/" + item.id).then(function() {
        vm.items.splice(index, 1);
      });
    },

    reset() {
      this.getAllPermissions();
      this.show = false;
      this.roleForEdit.id = null;
      this.edit_index = -1;
    },
    saved(item) {
      if (this.edit_index == -1) this.items.push(item);
      else Object.assign(this.items[this.edit_index], item);
      this.reset();
    }
  },

  created() {
    this.getRoles();
    this.getAllPermissions();
  }
};
</script>